"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationImpl = void 0;
var AxiosRequest_1 = require("./Infrastructure/AxiosRequest");
var Product_1 = require("./IO/Output/Product");
var Error_1 = require("./IO/Output/Error");
var UnknownError_1 = require("../utils/UnknownError");
var FilterApi_1 = require("./FilterApi");
/**
 * <h4>Recommendation implementation</h4>
 *
 * Documentation of Recommendation module is in interface description {@link RecommendationInterface}
 */
var RecommendationImpl = /** @class */ (function () {
    /**
     * @param config Customer configuration
     */
    function RecommendationImpl(config) {
        this.config = config;
        this.apiRequest = new AxiosRequest_1.AxiosRecommendationRequest(config);
    }
    RecommendationImpl.prototype.getRecommendation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = this.getRecommendationUrl(params);
                return [2 /*return*/, this.apiRequest.getRecommendations(url)
                        .then(function (response) {
                        return response.data.products.map(function (productResponse) {
                            return Product_1.Product.createFromResponse(productResponse);
                        });
                    })
                        .catch(function (reason) {
                        var _a, _b, _c;
                        throw new Error_1.RecommendationError((_c = (_b = (_a = reason.response) === null || _a === void 0 ? void 0 : _a.data.data) === null || _b === void 0 ? void 0 : _b.error_message) !== null && _c !== void 0 ? _c : UnknownError_1.UnknownError.messageByAxiosError(reason));
                    })];
            });
        });
    };
    RecommendationImpl.getPlacementId = function (placementId) {
        return placementId.replace('_qS_', '');
    };
    RecommendationImpl.prototype.getRecommendationUrl = function (params) {
        var host = this.config.getHost();
        var placementId = RecommendationImpl.getPlacementId(params.placementId);
        var requestParams = new URLSearchParams([
            ['customer', this.config.getCustomer()],
            ['qparams', RecommendationImpl.getQParamsBase64(params)]
        ]);
        return "https://qsdw1.".concat(host, "/QjC/").concat(placementId, "/?").concat(requestParams);
    };
    RecommendationImpl.getQParamsBase64 = function (params) {
        return Buffer.from(JSON.stringify(RecommendationImpl.getAllFilters(params))).toString('base64');
    };
    RecommendationImpl.getAllFilters = function (recommendationParams) {
        if (!(recommendationParams === null || recommendationParams === void 0 ? void 0 : recommendationParams.filters)) {
            return {};
        }
        return FilterApi_1.FilterApi.getFilterParams(recommendationParams.filters);
    };
    return RecommendationImpl;
}());
exports.RecommendationImpl = RecommendationImpl;
//# sourceMappingURL=RecommendationImpl.js.map